import React from 'react';
import { InputBase, InputAdornment, IconButton } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';

interface SearchBarProps {
  searchText: string;
  onSearchChange: (text: string) => void;
  onClearSearch: () => void;
  placeholder: string;
  disabled?: boolean;
  'data-testid'?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  searchText,
  onSearchChange,
  onClearSearch,
  placeholder,
  disabled = false,
  'data-testid': dataTestId,
}) => {
  return (
    <InputBase
      fullWidth
      placeholder={placeholder}
      value={searchText}
      onChange={e => onSearchChange(e.target.value)}
      disabled={disabled}
      data-testid={dataTestId}
      sx={{ typography: 'body2' }}
      startAdornment={
        <InputAdornment position="start">
          <SearchIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
        </InputAdornment>
      }
      endAdornment={
        searchText ? (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={onClearSearch}
              disabled={disabled}
              data-testid={dataTestId ? `${dataTestId}-clear` : undefined}
              sx={{ p: 0.25 }}
            >
              <ClearIcon sx={{ fontSize: 14 }} />
            </IconButton>
          </InputAdornment>
        ) : undefined
      }
    />
  );
};

export default SearchBar;
